import React, { useState, useEffect } from 'react';
import axios from 'axios';

const DatasetSelector = ({ apiPrefix, onDatasetLoaded, buttonText = "Load Dataset" }) => {
  const [datasets, setDatasets] = useState([]);
  const [selectedDataset, setSelectedDataset] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchDatasets();
  }, [apiPrefix]);

  const fetchDatasets = async () => {
    try {
      const res = await axios.get(`${apiPrefix}/datasets`);
      setDatasets(res.data.datasets || []);
    } catch (error) {
      console.error('Failed to load datasets:', error);
    }
  };

  const handleLoadDataset = async () => {
    if (!selectedDataset) return;
    setLoading(true);
    try {
      const res = await axios.post(`${apiPrefix}/select-dataset`, {
        dataset_id: parseInt(selectedDataset)
      });
      onDatasetLoaded(res.data);
    } catch (error) {
      console.error('Failed to load dataset:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatRows = (rows) => {
    if (!rows || rows === '?') return '';
    if (rows > 1000000) return `${(rows / 1000000).toFixed(1)}M`;
    if (rows > 1000) return `${(rows / 1000).toFixed(0)}K`;
    return rows;
  };

  return (
    <div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
      <select 
        value={selectedDataset} 
        onChange={(e) => setSelectedDataset(e.target.value)}
        disabled={loading}
        style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
      >
        <option value="">-- Select a dataset --</option>
        {datasets.map(ds => (
          <option key={ds.id} value={ds.id}>
            {ds.name} ({formatRows(ds.rows)} rows)
          </option>
        ))}
      </select>
      <button 
        onClick={handleLoadDataset} 
        disabled={!selectedDataset || loading}
        style={{ padding: '12px 24px', background: '#3498db', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
      >
        {loading ? 'Loading...' : buttonText}
      </button>
    </div>
  );
};

export default DatasetSelector;
